import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';

interface UseTotalAmountCalculationProps {
  tableRowsByFreelancer: { [key: string]: any[] };
  setValue: UseFormSetValue<any>;
}

export const useTotalAmountCalculation = ({
  tableRowsByFreelancer,
  setValue,
}: UseTotalAmountCalculationProps) => {
  
  useEffect(() => {
    const allFreelancerIds = Object.keys(tableRowsByFreelancer);
    
    if (allFreelancerIds.length === 0) {
      return;
    }

    let totalAmount = 0;

    allFreelancerIds.forEach(freelancerId => {
      const rows = tableRowsByFreelancer[freelancerId] || [];
      const freelancerTotal = rows.reduce((sum: number, row: any) => sum + (row.subtotal || 0), 0);
      totalAmount += freelancerTotal;
    });

    if (setValue && totalAmount > 0) {
      setValue('amount', totalAmount);
    }
  }, [tableRowsByFreelancer, setValue]);
};
